/**
 * 新しい版の案内バナー
 * 開いている画面より新しい版が配信されたら、全来場者画面の上部で再読み込みを案内します。
 */

import React from 'react';
import { Pressable, Text, View } from './WebPrimitives';
import useAppUpdateStatus from '../hooks/useAppUpdateStatus';
import { reloadCurrentPage } from '../utils/browserNavigation';

/**
 * 新しい版の案内バナー
 * @param {Object} props - プロパティ
 * @param {boolean} [props.reloadDisabled=false] - 送信中など、再読み込みで処理を中断させたくない間はtrue
 * @returns {JSX.Element | null} 新しい版がある場合だけ表示するバナー
 */
const AppUpdateBanner = ({ reloadDisabled = false }: { reloadDisabled?: boolean }) => {
  /** 新しい版の検知結果 */
  const { isUpdateAvailable } = useAppUpdateStatus();

  if (!isUpdateAvailable) {
    return null;
  }

  return (
    <View
      accessibilityRole="status"
      className="mb-3 flex-row items-center gap-2 rounded-none border-2 border-app-quest-night bg-[#EAF3FF] px-3 py-2"
      testID="app-update-banner"
    >
      <Text className="min-w-0 flex-1 text-xs font-extrabold text-app-quest-night">
        新しいバージョンがあります
      </Text>
      <Pressable
        accessibilityLabel="再読み込みして最新版にする"
        accessibilityRole="button"
        className="min-h-11 shrink-0 items-center justify-center border-2 border-app-quest-night bg-app-quest-gold px-3 disabled:opacity-50"
        disabled={reloadDisabled}
        onPress={reloadCurrentPage}
      >
        <Text accessible={false} className="text-xs font-extrabold text-app-quest-night">
          再読み込み
        </Text>
      </Pressable>
    </View>
  );
};

export default AppUpdateBanner;
